/**
 * @param {Order} order
 * @param {boolean} [isCredit]
 *
 * @returns {string}
 */
const generateOrderInvoiceID = (order, isCredit = false) => {
    if (isCredit) {
        return `${order.getOriginalRef()}-credit-1`;
    }

    return `${order.getOriginalRef()}-invoice-1`;
};

module.exports = {
    generateOrderInvoiceID,
};
